/* ⚛ REACT */
import React from "react";

/* 🎨 STYLES */
import { Container,  BarContainer, ContentContainer, NameText, TextSoma} from "./styles";

/**
 * Componente de barra horizontal para porcentagem
 * @param {String} name Texto para nomear a barra, ex: 'Nome 1'
 * @param {String} width Tamanho que deve ser coberto pela barra, ex: '5%'
 * @param {int} soma Número a ser exibido, ex: 8
 * @returns {React.Component}
*/
const HorizontalBar = ({name, width, soma}) => {
    return (
        <>
        <Container>
            <NameText>{name}</NameText>
            <BarContainer>
                <ContentContainer width={width}></ContentContainer>
                <TextSoma> {soma} </TextSoma>
            </BarContainer>
        </Container>
        </>
    );
};

export default HorizontalBar;